import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { MultiSelectOption } from "@/components/ui/multi-select";
import { ServiceDetail } from "@/types/service";
import { serviceQueryOptions } from "@/api/provider/admin/service-query";
import { medicationsQueryOptions } from "@/query/medications/medications";
import { measurementFieldQueryOptions } from "@/query/settings/measurement-fields";
export interface CarePlanLookupData {
  services: ServiceDetail[];
  medicationOptions: MultiSelectOption[];
  measurementOptions: MultiSelectOption[];
  isLookupsLoading: boolean;
  lookupError: Error | null;
}
export function useCarePlanLookupQueries() {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = serviceQueryOptions.list();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: t1,
    isPending: isServicesLoading,
    error: serviceError
  } = useQuery(t0);
  let t2;
  if ($[1] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const services = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = medicationsQueryOptions.list();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: t4,
    isPending: isMedicationsLoading,
    error: medicationError
  } = useQuery(t3);
  let t5;
  if ($[4] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const medications = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = measurementFieldQueryOptions.list();
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const {
    data: t7,
    isPending: isMeasurementsLoading,
    error: measurementError
  } = useQuery(t6);
  let t8;
  if ($[7] !== t7) {
    t8 = t7 === undefined ? [] : t7;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const measurementFields = t8;
  const isLookupsLoading = isServicesLoading || isMedicationsLoading || isMeasurementsLoading;
  let t9;
  if ($[9] !== medications) {
    t9 = medications.map(_temp);
    $[9] = medications;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const medicationOptions = t9;
  let t10;
  if ($[11] !== measurementFields) {
    t10 = measurementFields.map(_temp2);
    $[11] = measurementFields;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const measurementOptions = t10;
  const t11 = serviceError || medicationError || measurementError;
  let t12;
  if ($[13] !== isLookupsLoading || $[14] !== measurementOptions || $[15] !== medicationOptions || $[16] !== services || $[17] !== t11) {
    t12 = {
      services,
      medicationOptions,
      measurementOptions,
      isLookupsLoading,
      lookupError: t11
    };
    $[13] = isLookupsLoading;
    $[14] = measurementOptions;
    $[15] = medicationOptions;
    $[16] = services;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
}
function _temp2(f) {
  return {
    value: f.id,
    label: f.unit ? `${f.name} (${f.unit})` : f.name
  };
}
function _temp(m) {
  return {
    value: m.id,
    label: m.name
  };
}